type ModalSetter = (open: boolean) => void

const registry = new Map<string, ModalSetter>()

export function registerModal(id: string, setter: ModalSetter) {
	registry.set(id, setter)
}

export function unregisterModal(id: string) {
	registry.delete(id)
}

export function openModal(id: string) {
	const setter = registry.get(id)
	if (setter) setter(true)
	else if (import.meta.env.DEV) console.warn(`[modals] open: no modal registered with id "${id}"`)
}

export function closeModal(id: string) {
	const setter = registry.get(id)
	if (setter) setter(false)
}

export function closeAllModals() {
	registry.forEach((setter) => setter(false))
}

export const useVfm = () => ({
	open: openModal,
	close: closeModal,
	closeAll: closeAllModals,
})
